import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from "flarum/common/components/Link";
import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';
import avatar from "flarum/common/helpers/avatar";

/**
 *  标签页活跃人数
 */
export default class ActiveCreatorTag extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.users = [];
  }

  oncreate(vnode) {
    // const tag = m.route.param('tags');

    app.store
      .find('users', {
        sort: '-discussionCount',
        page: { limit: 5, offset: 0 },
      })
      .then((results) => {
        this.users = results;
        this.loading = false;
        m.redraw();
      });
  }

  className() {
    return  'active-creators-widget ruko-widget';
  }

  title() {
    return  app.translator.trans('acme-ruko.forum.widget.active_creators');
  }

  content() {
    if (this.loading) {
      return <LoadingIndicator />;
    }
    return (
      <div className="Widget-SectionList">
        <ul className="section-ul">
          {this.users?.map((user) => {
            return (
              <li class="section-box tag-widget">
                <Link className="tag-widget-user-left" href={app.route.user(user)} alt={user.avatarUrl()}>
                  {avatar(user || null)}
                </Link>
                <div className="tag-widget-right">
                  <Link className="tag-widget-right-username" href={app.route.user(user)} alt={user.avatarUrl()}>
                    {user.username()}
                  </Link>
                  <div className="tag-widget-right-content">
                    <span className="tag-widget-right-content-post">
                      {app.translator.trans('acme-ruko.forum.widget.active_creator_post')}&nbsp;
                      {user.discussionCount()}
                    </span>
                    <span>|</span>
                    <span className="tag-widget-right-content-reply">
                      {app.translator.trans('acme-ruko.forum.widget.active_creator_reply')}&nbsp;
                      {user.commentCount()}
                    </span>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
